import { useEffect, useMemo, useState } from 'react';

const defaultOptions = {
  root: null,
  topOffset: '0px',
  rightOffset: '0px',
  bottomOffset: '0px',
  leftOffset: '0px',
  threshold: 1
};

export const useOnScreen = (ref, options) => {
  const [isIntersecting, setIntersecting] = useState(null);

  const internalOptions = useMemo(() => {
    const { root, topOffset, rightOffset, bottomOffset, leftOffset, threshold } = options;
    const normalizedOptions = {};
    if (root) normalizedOptions.root = options.root;
    if (topOffset) normalizedOptions.topOffset = typeof topOffset === 'number' ? `${topOffset}px` : topOffset;
    if (rightOffset) normalizedOptions.rightOffset = typeof rightOffset === 'number' ? `${rightOffset}px` : rightOffset;
    if (bottomOffset) normalizedOptions.bottomOffset = typeof bottomOffset === 'number' ? `${bottomOffset}px` : bottomOffset;
    if (leftOffset) normalizedOptions.leftOffset = typeof leftOffset === 'number' ? `${leftOffset}px` : leftOffset;
    if (threshold) normalizedOptions.threshold = threshold;
    return { ...defaultOptions, ...normalizedOptions };
  }, [options]);

  const observer = useMemo(
    () =>
      new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting), {
        root: internalOptions.root,
        rootMargin: `${internalOptions.topOffset} ${internalOptions.rightOffset} ${internalOptions.bottomOffset} ${internalOptions.leftOffset}`,
        threshold: internalOptions.threshold
      }),
    [internalOptions]
  );

  useEffect(() => {
    if (!ref.current) return;
    observer.observe(ref.current);
    // Remove the observer as soon as the component is unmounted
    return () => {
      observer.disconnect();
    };
  }, [ref, observer]);

  return isIntersecting;
};
